import { useQuery } from 'react-query';

import { AuthStore } from '@/domain/models/Store';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { StoreService } from '@/services/Stores/StoreService';

interface Stores {
  stores: AuthStore[];
  isLoading: boolean;
  isError: Error | null;
}

export const useAuthStores = (required: boolean): Stores => {
  const storesService = new StoreService(getClient());

  const {
    data: stores = [],
    error,
    isLoading,
  } = useQuery<AuthStore[], Error>(
    'stores',
    () => storesService.list().catch((error: Error) => errorHandler({ error })),
    {
      enabled: required,
    }
  );

  return {
    stores,
    isLoading,
    isError: error,
  };
};
